export enum Role {
  // CAS
  CAS = 1,
  // Helpdesk
  Helpdesk = 2,
  // Administrator MZOM
  MinistryAdministrator = 3,
  // Stručno povjerenstvo MZOM
  MinistryCommittee = 4,
  // Čelnik UO/GU
  CountyLeader = 5,
  // Administrator UO/GU
  CountyAdministrator = 6,
  // Stručno povjerenstvo UO/GU
  CountyCommittee = 7,
  // Ravnatelj ustanove
  InstitutionPrincipal = 8,
  // Administrator ustanove
  InstitutionAdministrator = 9,
  // Stručno povjerenstvo ustanove
  InstitutionCommittee = 10,
  // Roditelj/Skrbnik
  Parent = 11,
  // Stručno povjerenstvo ispostave
  RegionalCommittee = 12,
  // Osnivač
  Founder = 13,
}
